export const SEEKBAR_PERCENT_INIT = 0;
